import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['firstName', 'lastName', 'phone', 'floorAndDoorShipping', 'streetShipping', 'zipCodeShipping', 'cityShipping', 'floorAndDoorBilling', 'streetBilling', 'zipCodeBilling', 'cityBilling', 'taxIdBilling']

  connect () {
  }

  addressChanged (event) {
    const addressType = event.target.dataset.type
    const firstName = event.target.dataset.firstName
    const lastName = event.target.dataset.lastName
    const phone = event.target.dataset.phone
    const floorAndDoor = event.target.dataset.floorAndDoor
    const street = event.target.dataset.street
    const zipCode = event.target.dataset.zipCode
    const city = event.target.dataset.city
    const billingFloorAndDoor = event.target.dataset.billingFloorAndDoor
    const billingStreet = event.target.dataset.billingStreet
    const billingZipCode = event.target.dataset.billingZipCode
    const billingCity = event.target.dataset.billingCity

    const updateTargetElements = (targets, value) => {
      targets.forEach((target) => {
        if (target.tagName === 'INPUT') {
          target.value = value || ''
        } else {
          target.innerText = value || ''
        }
      })
    }

    if (addressType === 'shipping') {
      updateTargetElements(this.firstNameTargets, firstName)
      updateTargetElements(this.lastNameTargets, lastName)
      updateTargetElements(this.phoneTargets, phone)
      updateTargetElements(this.floorAndDoorShippingTargets, floorAndDoor)
      updateTargetElements(this.streetShippingTargets, street)
      updateTargetElements(this.zipCodeShippingTargets, zipCode)
      updateTargetElements(this.cityShippingTargets, city)
    } else if (addressType === 'billing') {
      updateTargetElements(this.firstNameTargets, firstName)
      updateTargetElements(this.lastNameTargets, lastName)
      updateTargetElements(this.phoneTargets, phone)
      updateTargetElements(this.floorAndDoorBillingTargets, billingFloorAndDoor)
      updateTargetElements(this.streetBillingTargets, billingStreet)
      updateTargetElements(this.zipCodeBillingTargets, billingZipCode)
      updateTargetElements(this.cityBillingTargets, billingCity)
    }
  }
}
